/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * House Services Data
 */

// Icons
import {
    MdOutlineSell,
    MdPersonOutline,
    MdWineBar
} from 'react-icons/md';

import { SiCoffeescript } from 'react-icons/si';
import { CgBee } from 'react-icons/cg';
import { BsFlower3 } from 'react-icons/bs';

const service1HtmlText = (
    <>
        <p className="text-dark mb-0">Check In: <span className="text-muted mb-0">A partir das 15h</span></p>
        <p className="text-dark mb-0">Check Out: <span className="text-muted mb-0">Até às 12h</span></p>
    </>
);

export const SERVICES = [
    {
        id: 0,
        icon: (<MdPersonOutline/>),
        title: 'Receção',
        html: (service1HtmlText)
    },
    {
        id: 1,
        icon: (<SiCoffeescript/>),
        title: 'Pequeno Almoço',
        text: 'À base de produtos regionais, inclui sumos naturais, leite, café, fruta da epoca, diversos tipos de pão e cereais, mel, pólen, bolos e compotas caseiras.'
    },
    {
        id: 2,
        icon: (<BsFlower3 />),
        title: 'Spa',
        text: 'Não perca a oportunidade de vivenciar uma experiência única: um banho revitalizante em ofurô com produtos apícolas e uma massagem com mel.'
    },
    {
        id: 3,
        icon: (<MdWineBar />),
        title: 'Bar Típico com Esplanada',
        text: 'Saboreie os petiscos típicos da região num espaço acolhedor e exclusivo.'
    },
    {
        id: 4,
        icon: (<MdOutlineSell />),
        title: 'Venda de Produtos Regionais',
        text: 'Na zona da receção poderá adquirir o famoso e conceituado “Mel da Serra do Caramulo” e diversos produtos apícolas de produção própria.'
    },
    {
        id: 5,
        icon: (<CgBee />),
        title: 'Experiências Apícolas',
        text: 'Conheça uma das atividades mais importantes da região e desfrute das potencialidades terapêuticas e gastronómicas dos produtos apícolas:',
        textBullets: [
            {
                id: 0,
                text: 'Participação na cresta do mel'
            },
            {
                id: 1,
                text: 'Provas de degustação de mel'
            },
            {
                id: 2,
                text: 'Refeições gastronómicas de demonstração'
            },
            {
                id: 3,
                text: 'Massagens com mel'
            },
            {
                id: 4,
                text: 'Banho de imersão em ofurô com mel e plantas medicinais'
            },
        ]
    },
]